module.exports = __webpack_public_path__ + "static/media/image_9.c90a56d5.png";